import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a commercial stainless deep fryer, 0.4 x 0.6 x 0.9 m:
// steel body, two dark oil-vat openings on top, two raised basket handles
// (thin bars) and a control strip on the front (+Z).
const STEEL = "#aab2b8";
const STEEL_DARK = "#8f979d";
const MATTE_BLACK = "#2e2e30";
const OIL = "#3a3f44";

export const deepFryer = defineModel({
  id: "deep-fryer",
  batchId: "modern",
  name: "Deep Fryer",
  tags: ["modern", "interior", "appliance", "kitchen", "restaurant", "cooking"],
  summary: "A commercial stainless deep fryer with two oil vats and basket handles.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // steel body
      { geometry: new THREE.BoxGeometry(0.4, 0.86, 0.6), color: STEEL, position: [0, 0.45, 0] },
      // top plate
      { geometry: new THREE.BoxGeometry(0.4, 0.03, 0.6), color: STEEL_DARK, position: [0, 0.895, 0] },
      // two dark oil-vat openings on top
      { geometry: new THREE.BoxGeometry(0.14, 0.02, 0.4), color: OIL, position: [-0.1, 0.915, -0.04] },
      { geometry: new THREE.BoxGeometry(0.14, 0.02, 0.4), color: OIL, position: [0.1, 0.915, -0.04] },
      // basket handles: a vertical stem and a horizontal grip bar per vat
      { geometry: new THREE.BoxGeometry(0.02, 0.14, 0.02), color: MATTE_BLACK, position: [-0.1, 0.98, -0.22] },
      { geometry: new THREE.BoxGeometry(0.1, 0.02, 0.02), color: MATTE_BLACK, position: [-0.1, 1.05, -0.22] },
      { geometry: new THREE.BoxGeometry(0.02, 0.14, 0.02), color: MATTE_BLACK, position: [0.1, 0.98, -0.22] },
      { geometry: new THREE.BoxGeometry(0.1, 0.02, 0.02), color: MATTE_BLACK, position: [0.1, 1.05, -0.22] },
      // control strip on the front
      { geometry: new THREE.BoxGeometry(0.34, 0.1, 0.02), color: MATTE_BLACK, position: [0, 0.78, 0.305] },
      // two control knobs
      {
        geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.02, 8),
        color: STEEL,
        position: [-0.08, 0.78, 0.32],
        rotation: [Math.PI / 2, 0, 0],
      },
      {
        geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.02, 8),
        color: STEEL,
        position: [0.08, 0.78, 0.32],
        rotation: [Math.PI / 2, 0, 0],
      },
    ];
  },
  animations: [],
});
